import { statusColors } from "../../theme/status";
import { F } from "../../theme/tokens";

// The one small circular status/indicator dot used throughout the portal —
// the audit log's success/fail marker and the notification drawer's unread
// marker used to each hand-roll their own (8px, 7px) instead of this (5px,
// StatusBadge's own), so three conceptually identical dots rendered at three
// different sizes depending on which screen you were on. DOT_SIZE is the one
// number to change if that ever needs to move.
export const DOT_SIZE = 6;
export function Dot({ color, size = DOT_SIZE, style }: { color: string; size?: number; style?: React.CSSProperties }) {
  return <span style={{ width: size, height: size, borderRadius: "50%", background: color, flexShrink: 0, ...style }} />;
}

export function StatusBadge({ status }: { status: string }) {
  const c = statusColors[status] ?? { bg: "#f3f4f6", fg: "#6b7280" };
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: "6px", background: c.bg, color: c.fg, borderRadius: "9999px", padding: "3px 10px", fontSize: "11px", fontWeight: 600, fontFamily: F, whiteSpace: "nowrap", letterSpacing: "0.01em" }}>
      <Dot color={c.fg} />
      {status}
    </span>
  );
}
